<template>
	<div>		
		<div class="page-filter-box" v-if="sessionList">
		    <el-row>			        
				<el-col :span="4">
					<el-select v-model="sessionIdText" placeholder="请选择" size="medium" @change="changeActivity" clearable>						    
					    <el-option label="整场演出" value=""></el-option>
						<el-option v-for="(item, index) in sessionList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-col>
		         <el-col :span="3">
		            <el-radio-group v-model="timeType" class="MR20" size="medium" @change="getTime">
		                <el-radio-button :label="0">小时</el-radio-button>
		            	<el-radio-button :label="1">天</el-radio-button>
		            </el-radio-group>
		        </el-col>					
		        <el-col :span="8" >
					   <el-date-picker v-model="daterange" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :clearable="false" unlink-panels :picker-options="pickerOptions" @change="daterangeChange"></el-date-picker>
		        </el-col>
				<el-col :span="5">
					<div class="color-danger ML20" >按小时统计只能看最多30天的数据<br>按天统计只能看最多一年的数据</div>
				</el-col>					
		    </el-row>
		</div>
		<div class="content">
		   <div id="chartContainer" ref="chartContainer"></div>
		</div>
	</div>
</template>

<script>
	import { Chart } from '@antv/g2';
	export default {
    props: {
        activityId: {
            type: [Number, String],
            default: () => null
        },
        haveEditAudit: {
            type: Boolean,
            default: false
        },
        
    },
    components: {  },
    data() {
        return{
           dataLoading: false,
           daterange: [],           
           activityType:0,
           timeType:1,
           startTime:'',
           endTime:'',
           sessionId:'',
		   ticketId:'',
           sessionIdText:'',
           timeData:null,
           chart:null,
		   sessionList:null,
		   pickerMinDate1: "",//第一次选中的时间
		   pickerOptions: {
		       onPick: obj => {
		           this.pickerMinDate1 = new Date(obj.minDate).getTime();
		       },
		       disabledDate: (time) => {
		           if (this.pickerMinDate1 && time.getTime() <= Date.now()) {
		               const day1 = 730 * 24 * 3600 * 1000;
		               let maxTime = this.pickerMinDate1 + day1;
		               let minTime = this.pickerMinDate1 - day1;
		               return time.getTime() > maxTime || time.getTime() < minTime;
		           }else{
		               return time.getTime() > Date.now();
		           }
		       }
		   },
        }
    },
   created() {
       this.getTime(1)
	   this.getActivityName()
   },
    methods: {
		getTime(val){		
			this.$request({
				url: "/common/time",
				data: {},
				method: "post",
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1) {
						if( val == 1 ){
							this.daterange = [result[1].startTime,result[1].endTime]
							
						}else{
							this.daterange = [result[0].startTime,result[0].endTime]
						}
						this.getTimedata()
						  
					} else {
						this.$message.error(msg || "获取数据失败,请重试");
					}
				})
				.catch(() => {
					this.$message.error("获取数据失败,请重试");
				})
				.finally(() => {
					this.dataLoading = false;
				});  
		},
		getActivityName(){
			
			this.$request({
					url: "/missTicket/idNameSelect",
					params: {
						activityId: parseInt(this.activityId)
					},
					method: "post",
				})
			.then((res) => {
				const { state, msg, result } = res.data;
				if (state == 1) {
					this.sessionList = result
				} else {
					this.$message.error(msg || "获取数据失败,请重试");
				}
			})
			.catch(() => {
				this.$message.error("获取数据失败,请重试");
			})
			.finally(() => {
				this.dataLoading = false;
			});
		},
		changeActivity(value){
		 if( value.length == 32 ){
			this.ticketId = value
			this.sessionId = ''
		 }else{
			this.ticketId = ''
			this.sessionId = value
		 }		  			 
		  this.getTimedata()
		},
		 getTimedata(){				 
		   this.$request({
			   url: "/missTicket/timeStats",
			   data: { 
				   activityId: parseInt(this.activityId),
				   startTime:this.daterange && this.daterange[0] || '',
				   endTime:this.daterange && this.daterange[1] || '',
				   sessionId:this.sessionId,
				   ticketId:this.ticketId,
				   timeType:this.timeType
				},
			   method: "post",
		   })
		   .then((res) => {
			   const { state, msg, result } = res.data;
			   if (state == 1) {
				   this.timeData = result.lineData;
				   this.$nextTick(() => {
						this.drawChart();
				   })
			   } else {
				   this.$message.error(msg || "获取数据失败,请重试");
			   }
		   })
		   .catch(() => {
			   this.$message.error("获取数据失败,请重试");
		   })
		   .finally(() => {
			   this.dataLoading = false;
		   });
		},
		drawChart(){
			
		    if( this.chart ) this.chart.destroy();
		    
		    let _data = [];
		    const _dataArry = this.timeData;
		   
			_dataArry.map( item => {
			    item.value.map( v => {
			        _data.push({
			            name: item.name,
			            year: v.name,
			            value: parseFloat(v.value)
			        })
			    })
			}) 
			
			this.chart = new Chart({
			    container: 'chartContainer',
			    autoFit: true,
			    height: 420,
			});
			
			
		    this.chart.data(_data);			
		   
			
			if( this.timeData[0].value.length > 7 ){
				this.chart.option('slider', {
					start: (this.timeData[0].value.length - 7) / this.timeData[0].value.length,
					end: 1,
				});
			}	
			
			
			this.chart.tooltip({
				showCrosshairs: true,
				shared: true,
			});
			this.chart.legend('name', {
				position: 'top',
			});
			this.chart
				.line()
				.position('year*value')
				.color('name')
				.shape('smooth')
				.tooltip('name*value', (name, value) => {
				   // value = this.activeName == 1 ? parseFloat(value).toFixed(2) : value;
					return {
						name: name,
						value: value,
					};
				});
			
			this.chart.render();
		},
		//选择自定义时间段
		daterangeChange(e){
		   this.getTimedata()
		}
		
    }
}
</script>

<style>
</style>